import React from 'react'

import withStyles from '@material-ui/core/styles/withStyles'

/// @material-ui/core components
import Typography from '@material-ui/core/Typography'

const style = theme => ({
  subtitle: {
    '& span': {
      color: theme.palette.secondary.main,
      fontWeight: 600,
    },
  },
  gutterBottom: {
    marginBottom: '1.25rem',
  },
})

const ListHeader = ({ classes, title, subtitle }) => (
  <>
    <Typography gutterBottom variant="h6" color="primary">
      {title}
    </Typography>
    <Typography
      variant="body2"
      gutterBottom
      color="textSecondary"
      classes={{ gutterBottom: classes.gutterBottom }}
      className={classes.subtitle}
      dangerouslySetInnerHTML={{ __html: subtitle }}
    />
  </>
)

export default withStyles(style)(ListHeader)
